export default __webpack_public_path__ + "static/KG_Headshot_turtleneck_BW-698b62dea9b907aebd1ef2a14dfec668.jpg";